import { render, staticRenderFns } from "./HeaderUserMenu.vue?vue&type=template&id=341ba696&scoped=true"
import script from "./HeaderUserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderUserMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderUserMenu.vue?vue&type=style&index=0&id=341ba696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341ba696",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BugReport: require('/home/runner/work/assessment-service/assessment-service/frontend/components/BugReport.vue').default})
